// styles.js
import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const PageContent = styled.div`
  display: flex;
  margin-bottom: 80px;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 1142px;
  align-items: center;
`;

export const InstructionText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-weight: 500; /* Poppins Medium */
  font-size: 20px;
  line-height: 32px;
  color: #515151;
  // text-align: center;
  margin-top: 10px; 
  
`;
